<template>
    <StaticSpinner v-if="!isLoaded" />
    <div class="tournamentPromotion">
        <iframe
            v-if="promotionUrl"
            ref="promotionIframe"
            v-bind:src="promotionUrl"
            class="promotionIframe"
            allowfullscreen
            title="Tournament Center Promotion"
            v-on:load="isLoaded = true"
        />
    </div>
</template>

<script lang="ts" setup>
    import { useEventListener } from '@vueuse/core';
    import { ref, useTemplateRef } from 'vue';
    import StaticSpinner from '@/components/common/StaticSpinner.vue';
    import { getSportsPromotionUrl } from '@/core/lib/url';

    const promotionUrl = `${getSportsPromotionUrl()}?embed=1`;
    const isLoaded = ref(false);
    const iframeRef = useTemplateRef<HTMLIFrameElement>('promotionIframe');

    useEventListener(globalThis, 'message', (event: MessageEvent) => {
        const iframe = iframeRef.value;
        if (!iframe || event.source !== iframe.contentWindow || typeof event.data?.height !== 'number') return;

        iframeRef.value.style.height = `${event.data.height}px`;
    });
</script>

<style lang="scss" scoped>
.promotionIframe {
    width: 100%;
    border-width: 0;
}
</style>
